<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'distribuicao-equipamentos',
  data () {
    return {
      title: 'Distribuição Eequipamentos'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/distribuicao-equipamentos' || this.$router.currentRoute.path === '/distribuicao-equipamentos/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/distribuicao-equipamentos/index.vue